import { default as InterestFreePeriodDialog } from './InterestFreePeriodDialog';

export default InterestFreePeriodDialog;
